import { Message } from "semantic-ui-react";

export const Unauthorized = () => {
    return (
        <Message header="You do not have permission to view the content of this page" icon="ban" />
    );
};
